import { useEffect, useState } from "react";
import {
  getImpersonation,
  subscribeImpersonation,
  type ImpersonationState,
} from "@/lib/admin/impersonation";

/** Håller reda på om utvecklaren just nu ser appen som en användare. */
export const useImpersonation = (): ImpersonationState | null => {
  const [state, setState] = useState<ImpersonationState | null>(() => getImpersonation());

  useEffect(() => subscribeImpersonation(() => setState(getImpersonation())), []);

  return state;
};
